export default {
  0: { showTime: false, imageMaxWidth: 840 },
  1: { showTime: true, imageMaxWidth: 840 },
  2: { showTime: false, imageMaxWidth: 595 },
};
